import { GuestQuote } from "@/redux/apis/guest/types";
import { QuotePriceSummary } from "./QuotePriceSummary";

interface GuestQuotePriceSummaryProps {
  /** Full itemised guest quote (same shape as the authed quote). Undefined until it resolves. */
  quote?: GuestQuote;
  isQuotable: boolean;
  isLoading: boolean;
  missingFields: string[];
  className?: string;
}

/**
 * Guest variant of the Price Summary. The guest-quote endpoint now returns the SAME itemised shape as
 * the authed quote (Journey Cost / Extras / Service Fee / Credit Card Processing Fee / Total, all in AUD
 * dollars), so this simply delegates to the shared QuotePriceSummary the authed flow uses. Kept
 * as a thin seam so the guest summary can diverge later without touching the authed component.
 */
export const GuestQuotePriceSummary = (props: GuestQuotePriceSummaryProps) => <QuotePriceSummary {...props} />;
